import { render, staticRenderFns } from "./ApiTable.vue?vue&type=template&id=ec78a128&scoped=true"
import script from "./ApiTable.vue?vue&type=script&lang=js"
export * from "./ApiTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec78a128",
  null
  
)

export default component.exports